import { Modal, Box, TextField, MenuItem, Button, Typography, CardContent, Card, Paper } from '@mui/material'
import { useState, useEffect } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};


export default function AddEditLandRegistration(props) {
    const { rowId, addEditModalOpen, setAddEditModalOpen } = props
    const [landRegistrationData, setLandRegistrationData] = useState({
        gid: '',
        parcelCode: '',
        owner: '',
        oldOwner: '',
        dn: '',
        oldDn: '',
        note: ''
    })
    return (
        <Modal
            open={addEditModalOpen}
            onClose={() => {
                setAddEditModalOpen(false)
                // setDefaultWasteFeeData()
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card>
                <CardContent>
                    <Box
                        sx={style}
                        component='form'
                        onSubmit={(event) => {
                            if (rowId === undefined) {

                            } else {

                            }
                        }}
                    >
                        <Paper sx={{ p: 1 }}>
                            <Box>
                                <Typography variant='h5'>{rowId !== undefined ? 'แก้ไขข้อมูลทะเบียนคุม' : 'บันทึกข้อมูลทะเบียนคุม'}</Typography >
                                <TextField
                                    id="parcelCode"
                                    label="รหัสแปลงที่ดิน"
                                    value={landRegistrationData.parcelCode}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, parcelCode: event.target.value.toLocaleUpperCase() })}
                                />
                                <TextField
                                    id="owner"
                                    label="เจ้าของปัจจุบัน"
                                    value={landRegistrationData.owner}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, owner: event.target.value })}
                                />
                                <TextField
                                    id="oldOwner"
                                    label="เจ้าของเดิม"
                                    value={landRegistrationData.oldOwner}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, oldOwner: event.target.value })}
                                />
                                <TextField
                                    id="dn"
                                    label="เลขเอกสารสิทธิ์"
                                    value={landRegistrationData.oldOwner}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, oldOwner: event.target.value })}
                                />
                                <TextField
                                    id="oldDn"
                                    label="เลขเอกสารสิทธิ์เก่า"
                                    value={landRegistrationData.oldOwner}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, oldOwner: event.target.value })}
                                />
                                <TextField
                                    id="note"
                                    label="หมายเหตุ"
                                    value={landRegistrationData.oldOwner}
                                    onChange={(event) => setLandRegistrationData({ ...landRegistrationData, oldOwner: event.target.value })}
                                />
                            </Box>

                            <Button
                                variant='contained'
                                startIcon={<SaveIcon />}
                                type='submit'
                            >
                                บันทึกข้อมูล
                            </Button>
                            <Button
                                sx={{ marginLeft: '1ch' }}
                                variant='contained'
                                color='error'
                                startIcon={<CancelIcon />}
                            onClick={() => {
                                setAddEditModalOpen(false)
                            }}
                            >
                                ยกเลิก
                            </Button>
                        </Paper>
                    </Box>
                </CardContent>
            </Card>
        </Modal>
    )
}
